import React from "react";
import { Link, useLocation } from "react-router-dom";
import { HiChevronRight } from "react-icons/hi";

export const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <nav className="flex items-center space-x-1 text-sm">
      <Link
        to="/"
        className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
      >
        Home
      </Link>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;

        return (
          <React.Fragment key={name}>
            <HiChevronRight className="w-4 h-4 text-gray-400" />
            <Link
              to={routeTo}
              className={`
                ${
                  isLast
                    ? "text-indigo-600 dark:text-indigo-400 font-medium"
                    : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                }
                capitalize
              `}
            >
              {name.replace(/-/g, " ")}
            </Link>
          </React.Fragment>
        );
      })}
    </nav>
  );
};
